import ProjectList, { ProjectListConfig } from 'components/ProjectList'
import CameraModelSelector, { CameraModelSelectorConfig } from 'components/CameraModelSelector'
import FloorPlanUploader, { FloorPlanUploaderConfig } from 'components/FloorPlanUploader'
import LoginForm, { LoginFormConfig } from 'components/LoginForm'
import Permalink, { PermalinkConfig } from 'components/Permalink'
import EditLocation, { EditLocationConfig } from 'components/EditLocation'
import FovUploadsForm, { FovUploadsFormConfig } from 'components/FovPreview/FovUploadsForm'
import Locked, { LockedConfig } from 'components/Locked'
import ExportRunningError, { ExportRunningErrorConfig } from 'components/ExportRunningError'
import NewProjectAtLocation, { NewProjectAtLocationConfig } from 'components/NewProjectAtLocation'
import DeleteCamera, { DeleteCameraConfig } from 'components/DeleteCamera'
import EditProjectTitle, { EditProjectTitleConfig } from 'components/EditProjectTitle'
import LensModelSelector, { LensModelSelectorConfig } from 'components/LensModelSelector'
import AnalyticZonesSelector, { AnalyticZonesSelectorConfig } from 'components/AnalyticZonesSelector'
import DoorControllerDesigner, { DoorControllerDesignerConfig } from 'components/DoorControllerDesigner'
import DoorControllerModelSelector, { DoorControllerModelSelectorConfig } from 'components/DoorControllerModelSelector'
import ExpansionControllerModelSelector, { ExpansionControllerModelSelectorConfig } from 'components/ExpansionControllerModelSelector'

const MobileFloorPlanUploader = FloorPlanUploader
const MobileFloorPlanUploaderConfig = FloorPlanUploaderConfig

export const modals = { ProjectList, CameraModelSelector, FloorPlanUploader, LoginForm, Permalink, EditLocation,
    FovUploadsForm, Locked, ExportRunningError, NewProjectAtLocation, DeleteCamera, EditProjectTitle,
    MobileFloorPlanUploader, LensModelSelector, AnalyticZonesSelector, DoorControllerDesigner, DoorControllerModelSelector,
    ExpansionControllerModelSelector }
export const modalConfigurations = { ProjectListConfig, CameraModelSelectorConfig, FloorPlanUploaderConfig, LoginFormConfig,
    PermalinkConfig, EditLocationConfig, FovUploadsFormConfig, LockedConfig, ExportRunningErrorConfig,
    NewProjectAtLocationConfig, DeleteCameraConfig, EditProjectTitleConfig, MobileFloorPlanUploaderConfig,
    LensModelSelectorConfig, AnalyticZonesSelectorConfig, DoorControllerDesignerConfig, DoorControllerModelSelectorConfig,
    ExpansionControllerModelSelectorConfig }



// WEBPACK FOOTER //
// ./src/components/Modal/configurations.js